import { render } from "./FondoAnimado.vue?vue&type=template&id=af7f9a90"
import script from "./FondoAnimado.vue?vue&type=script&lang=js"
export * from "./FondoAnimado.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__